import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const avatarImage = css`
	object-fit: cover;
`;

export const Header = styled.header`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.8rem;
`;
